"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceKey = void 0;
var PreferenceKey;
(function (PreferenceKey) {
    PreferenceKey["RECOMMENDED_ASSESSMENT"] = "affirm_recommended";
    PreferenceKey["MY_ASSESSMENTS_FILTERS"] = "affirm_my_assessments_filters";
    PreferenceKey["GM_LIBRARY_FILTERS"] = "affirm_library_filters";
})(PreferenceKey || (exports.PreferenceKey = PreferenceKey = {}));
